// src/components/machineList3.js
import React, { useEffect, useState } from "react";
import { getModelsByProduct } from "../api";

const ModelListBut = ({ id_c, id_prod, onSelect }) => {
  const [models, setModels] = useState([]);

  useEffect(() => {
    const fetchModels = async () => {
      if (id_prod) {
        const data = await getModelsByProduct(id_c, id_prod);
        setModels(data.models);
      } else {
        setModels([]); // limpia si no hay producto
      }
    };
    fetchModels();
  }, [id_c, id_prod]);

  return (
    <select
      className="input1"
      onChange={(e) => onSelect(e.target.value)}
      required
      disabled={!id_prod}
    >
      <option value="">
        {id_prod ? "-- Selecciona un modelo --" : "-- Selecciona un producto primero --"}
      </option>
      {models.map((m) => (
        <option key={m.model} value={m.model}>
          {m.model}
        </option>
      ))}
    </select>
  );
};

export default ModelListBut;